import { useAutocompleteSource } from '@eas/common-web';
import { DictLegalFormAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useLegalForms() {
  return useAutocompleteSource<DictLegalFormAutocomplete>({
    url: `${EvidenceApiUrl.DICT_LEGAL_FORM}/autocomplete`,
  });
}
